import { Component, EventEmitter, Input } from '@angular/core';
import { MogoDropzoneComponent } from '../../../../../../../shared/mogo-dropzone/mogo-dropzone.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Job } from '../../../../../../../shared/Jobbing/models/Job';

@Component({
  selector: 'app-jobbing-attachment-form',
  standalone: true,
  imports: [MogoDropzoneComponent, ReactiveFormsModule],
  templateUrl: './jobbing-attachment-form.component.html',
  styleUrl: './jobbing-attachment-form.component.scss'
})
export class JobbingAttachmentFormComponent {
  @Input()
  formGroup!: FormGroup;


  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('attachments', this.fb.group({
      documents: this.fb.control<File[]>([])
    }));
  }

  getFormGroup() {
    if (!this.formGroup.get('attachments')) {
      this.initializeForm();
    }
    return this.formGroup.get('attachments') as FormGroup;
  }
}
